import { View, Text, Pressable } from 'react-native';
import styled from 'styled-components/native';

import {
  elRed,
  elGray
} from '../../styles/colors';

export const ButtonContainer = styled(View)`
`;

export const STATUSES = [
  'Future',
  'Pending',
  'Live',
  'Processing',
  'Closed'
];

export const preSale = 'blue';
export const activeSale = `green`;
export const postSale = `${elRed}`;

export const BoldText = styled(Text)`
  font-weight: 600;
`;

export const NameStatusLabel = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const NameLabel = styled(Text)`
  font-weight: bold;
  align-self: start;
`;

export const StatusLabel = styled(Text)`
  font-weight: bold;
  align-self: end;
`;

export function getStatusType(status) {
  switch(status) {
    case 'Future':
    case 'Building Run List':
    case 'Ready For Sale':
    case 'Pending':
      return preSale;
      break;
    case 'Pre-Bid':
    case 'Live':
      return activeSale;
      break;
    case 'Processing':
    case 'Closed':
      return postSale;
      break;
  }
}

export const getStatus = (status, tableType) => {
  switch(status) {
    case 'Future':
    case 'Building Run List':
    case 'Ready For Sale':
    case 'Pending':
      return tableType ? 'pre' : 'Upcoming';
      break;
    case 'Pre-Bid':
    case 'Live':
      return tableType ? 'live' : 'Live';
      break;
    case 'Processing':
    case 'Closed':
      return tableType ? 'post' : 'Post';
      break;
  }
}

export const TabButtonContainer = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`

export const TabButton = styled(Pressable)`
  border: solid black 1px;
  width: 48%;
  border-radius: 3px;
  padding: 5px;
`
